export default "__VITE_ASSET__60316616__"